

import { createAsyncThunk, createSlice, nanoid } from "@reduxjs/toolkit";
import axiosInstance from "../../axios/axiosInstance";

const initialState = {

    //! bu ekranın sol tarafındaki(control) bölümün görünümünü kontrol eden
    isControlContainerOpen: true,

    //! bu ekranın sağ tarafındaki(rota control) bölümün görünümünü kontrol eden
    isRouteControlContainerOpen: true,

    //! bu center alt kısımdaki geri dönüş garajları ve sera gazı sonuçlarını nın görünümünü kontrol eden
    isCenterResultContainerOpen: false,
    
    //! bu kullanıcının inputlara girdiği rota bilgileri
    route: [
        {
            id: nanoid(),
            lat: "",
            lng: "",
            isStopOver: false,
            
            location:"",
            cityId: "",
            region: "",
            mernis: ""
        },
        {
            id: nanoid(),
            lat: "",
            lng: "",
            isStopOver: false,
            
            location:"",
            cityId: "",
            region: "",
            mernis: ""
        },
    ],

    //! araç türü
    truckType: null,

    //! tonaj datası (araca göre değişecek)
    tonajData: "",

    //! bu seçilen araca göre tonaj optionları ayarlayan
    tonajOptions: [],

    //! km datası (seçilen rotaya göre değişecek)
    kmData: "",

    //! bu kullanıcının seçtiği rota
    selectedRouteItem: null, 

    //! iş süresi (km datasına göre )değişecek
    jobDuration: "",

    //! bu apiden gelen rota verisini tutan
    routeResultList: [],

    //! bu gelen veriyi decode eden(kullanılabilir hale getiren)
    decodedPolylineList: [],

    //! bu apiden gelen rota traffic verisini tutan
    routeTrafficResultList: [],

    //! toplam otoyol ücreti
    totalHighwayPrice: "",

    //! mevcut eklenen köprü listesi
    currentBridgeList: [],

    //! bu toplam köprü ücreti
    totalBridgePrice: "",

    //! mevcut eklenen otoyol listesi
    currentHighwayList: [],

    //! mevcut eklenen feribot listesi
    currentFerryList: [],

    //! bu toplam feribot ücreti
    totalFerryPrice: "",

    //! o sırada ekranda gözükecek extra price listesi
    activeExtraPriceList: null,

    isLoadingGetNakliyeHesaplama: false,

    //! response dan gelen(bizim apiden)
    resCostData: null,

    //! bu response dan gelen return garages listesi(bizim apiden)
    resReturnGaragesList: [],

    //! response dan gelen serda gazı bilgileri(bizim apiden)
    resSeraData: null,

    //! bu garage ların içinden seçilen varsa 
    selectedGarageItem: null,

    //! bu center alt kısımdaki geri dönüş garajları ve sera gazı sonuçlarını hangsinin görüntüleneceğini kontrol eden
    extraResultActiveTab: 1,

    //! bu süreyi backendin hesaplma yapıp yapmayacağını belirleyen şey (eğer ki istek atılmadan önce duratio inputu güncellenmişse backend süreyi hesaplamayacan yoksa hesaplayacak)
    isDurationStrict: false

}



export const getNakliyeHesaplama = createAsyncThunk("nakliyeHesaplama/getNakliyeHesaplama", async(body, thunkApi)=> {
    try {
       
        const {data} = await axiosInstance.post(`/MaliyetHesabi/MaliyetHesabiCalculate`, body)

        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})





const nakliyeHesaplamaSlice = createSlice({
    name: "nakliyeHesaplama",
    initialState,
    reducers: {
        //! bu control kısmının açılıp/kapanmasını sağlıyor
        setControlContainer: (state, action) => {
            state.isControlContainerOpen = action.payload
        },

        //! bu rota control kısmının açılıp/kapanmasını sağlıyor
        setRouteControlContainer: (state,action) => {
            state.isRouteControlContainerOpen = action.payload
        },

        //! bu center alt kısımdaki geri dönüş garajları ve sera gazı sonuçlarını nın görünümünü kontrol eden
        setIsCenterResultContainer: (state,action) => {
            state.isCenterResultContainerOpen = action.payload
        },

        //! bu center alt kısımdaki geri dönüş garajları ve sera gazı sonuçlarını hangsinin görüntüleneceğini kontrol eden
        setExtraResultActiveTab: (state, action) => {
            
            state.extraResultActiveTab = action.payload
        },

        //! bu garage lara extra fiyat girildiğinde güncellemek için (digerGiderler)
        updateGarageItem: (state,action) => {
            state.resReturnGaragesList = state.resReturnGaragesList.map((item) => {
                if(item.id === action.payload.id){
                    return {
                        ...item,
                        digerGiderler: action.payload.digerGiderler
                    }
                }
                else{
                    return item
                }
            })
        },

        //! bu garage ların içinden seçilen varsa 
        setSelectedGarageItem: (state,action) => {
            state.selectedGarageItem = action.payload
        },

        //! bu route u update eden
        updateRoute: (state,action) => {
            
            state.route = state.route.map((item) =>{
                if(item.id === action.payload.id){
                    return {
                        ...item,
                        ...action.payload,
                    }
                }
                else{
                    return item
                }
            })
        },

        //! rota noktasını silmek için
        removeRouteItem: (state, action) => {
            state.route = state.route.filter(item => {
                return item.id !== action.payload.id
            })
        },

        //! araç türünü güncelleyen
        updateTruckType: (state, action) => {
            state.truckType = action.payload
        },

        //! tonaj datasını ayarlayan
        updateTonajData: (state,action) => {
            state.tonajData = action.payload
        },

        //! bu seçilen araca göre tonaj optionları ayarlayan
        updateTonajOptions: (state, action) => {
            state.tonajOptions = action.payload
        },

        //! km Datasını ayarlayan
        updateKmData: (state, action) => {
            state.kmData = action.payload
        },

        updateSelectedRouteItem: (state,action) => {
            state.selectedRouteItem = action.payload
        },

        //! iş süresini ayarlayan
        updateJobDuration: (state,action) => {
            state.jobDuration = action.payload
        },

        //! otoyol fiyatını güncelleyen
        updateTotalHighwayPrice: (state,action) => {
            state.totalHighwayPrice = action.payload
        },

        //! köprü ücretini güncelleyen
        updateCurrentBridgeList:(state,action) => {
            state.totalBridgePrice = state.currentBridgeList.reduce((acc, obj) => acc + obj.ucret, 0) + action.payload.ucret
            state.currentBridgeList = [action.payload, ...state.currentBridgeList]
        },

        //! köprü ücretini manuel input ile değiştimek isterse
        updateTotalBridgePrice: (state,action) => {
            state.totalBridgePrice = action.payload
        },

        //! bu köprü listesinden item silmek için
        deleteCurrentBridgeItem: (state, action) => {
            state.currentBridgeList = state.currentBridgeList.filter((item) => {
                return item.id !== action.payload.id
            })
            state.totalBridgePrice = state.totalBridgePrice - action.payload.ucret
        },

        //! mevcut eklenen otoyol listesi
        updateCurrentHighwayList: (state,action) => {
            state.currentHighwayList = action.payload
        },

        //! mevcut eklenen feribot listesi
        updateCurrentFerryList: (state,action) => {
            state.totalFerryPrice = state.currentFerryList.reduce((acc, obj) => acc + obj.ucret, 0) + action.payload.ucret
            state.currentFerryList = [action.payload, ...state.currentFerryList]
        },

        //! feribot ücretini manuel input ile değiştimek isterse
        updateTotalFerryPrice: (state,action) => {
            state.totalFerryPrice = action.payload
        },
        
        //! bu feribot listesinden item silmek için
        deleteCurrentFerryItem: (state, action) => {
            state.currentFerryList = state.currentFerryList.filter((item) => {
                return item.id !== action.payload.id
            })
            state.totalFerryPrice = state.totalFerryPrice - action.payload.ucret
        },

        //! o sırada ekranda gözükecek extra price listesi
        updateActiveExtraPriceList: (state,action) => {
            state.activeExtraPriceList = action.payload
        },

        //! bu apiden gelen rota verisini tutan
        setRouteResultList: (state,action) => {
            state.routeResultList = action.payload
        },

        //! bu gelen veriyi decode eden(kullanılabilir hale getiren)
        setDecodedPolylineList: (state,action) => {
            state.decodedPolylineList = action.payload
        },

        //! bu apiden gelen rota traffic verisini tutan
        setRouteTrafficResultList: (state, action) => {
            state.routeTrafficResultList = action.payload
        },

        //! bu yeni bir rota ekleyen
        addNewRoutePoint: (state,action) => {
            state.route = [...state.route,  {
                id: nanoid(),
                lat: "",
                lng: "",
                isStopOver: false,
                
                location:"",
                cityId: "",
                region: "",
                mernis: ""
            }]
        },

        //! bu süreyi backendin hesaplma yapıp yapmayacağını belirleyen şey (eğer ki istek atılmadan önce duratio inputu güncellenmişse backend süreyi hesaplamayacan yoksa hesaplayacak)
        setIsDurationStrict: (state,action) => {
            state.isDurationStrict = action.payload
        },

        //! tüm verileri sıfırlama
        clearNakliyeCalcForm: (state, action) => {
            return initialState;
        }

    },
    
    extraReducers:(builder)=> {
        builder

        //! getNakliyeHesaplama
        .addCase(getNakliyeHesaplama.pending, (state)=> {
            state.isLoadingGetNakliyeHesaplama = true
            state.isDurationStrict = false
        })

        .addCase(getNakliyeHesaplama.fulfilled, (state, action)=> {
            state.isLoadingGetNakliyeHesaplama = false
            state.isCenterResultContainerOpen = true

            const {
                totalLowMaliyet,
                totalMiddleMaliyet,
                totalHighMaliyet,
                getMernisCodeDistrictListDto,
                emisyonSonuc,
                agacSayisi,
                gunData
            } = action.payload.data 

            state.resCostData = {
                highCost: totalHighMaliyet,
                midCost: totalMiddleMaliyet,
                lowCost: totalLowMaliyet
            }
            state.jobDuration = gunData
            state.resReturnGaragesList = getMernisCodeDistrictListDto.truckGarages.$values
            state.resSeraData = {emisyonSonuc, agacSayisi}
        })

        .addCase(getNakliyeHesaplama.rejected, (state, action)=> {
            state.isLoadingGetNakliyeHesaplama = false
        })
    
    }
})


export const {

    //! bu control kısmının açılıp/kapanmasını sağlıyor
    setControlContainer,

    //! bu rota control kısmının açılıp/kapanmasını sağlıyor
    setRouteControlContainer,

    //! bu center alt kısımdaki geri dönüş garajları ve sera gazı sonuçlarını nın görünümünü kontrol eden
    setIsCenterResultContainer,

    //! bu center alt kısımdaki geri dönüş garajları ve sera gazı sonuçlarını hangsinin görüntüleneceğini kontrol eden
    setExtraResultActiveTab,

    //! bu garage ların içinden seçilen varsa 
    setSelectedGarageItem,

    //! bu garage lara extra fiyat girildiğinde güncellemek için (digerGiderler)
    updateGarageItem,

    //! bu route u update eden
    updateRoute,

    //! rota noktasını silmek için
    removeRouteItem,

    //! araç türünü güncelleyen
    updateTruckType,

    //! tonaj datasını ayarlayan
    updateTonajData,

    //! bu seçilen araca göre tonaj optionları ayarlayan
    updateTonajOptions,

    //! km datasını ayarlayan
    updateKmData,
    
    //! bu kullanıcının seçtiği rota
    updateSelectedRouteItem,

    //! iş süresini ayarlayan
    updateJobDuration,

    //! otoyol fiyatını güncelleyen
    updateTotalHighwayPrice,

    //! mevcut eklenen feribot listesi
    updateCurrentFerryList,

    //! bu feribot listesinden item silmek için
    deleteCurrentFerryItem,

    //! mevcut eklenen otoyol listesi
    updateCurrentHighwayList,
    
    //! mevcut eklenen köprü listesi
    updateCurrentBridgeList,

    //! feribot ücretini manuel input ile değiştimek isterse
    updateTotalFerryPrice,

    //! köprü ücretini manuel input ile değiştimek isterse
    updateTotalBridgePrice,

    //! bu köprü listesinden item silmek için
    deleteCurrentBridgeItem,

    //! o sırada ekranda gözükecek extra price listesi
    updateActiveExtraPriceList,

    //! bu gelen veriyi decode eden(kullanılabilir hale getiren)
    setDecodedPolylineList,

    //! bu apiden gelen rota verisini tutan
    setRouteResultList,

    //! bu apiden gelen rota traffic verisini tutan
    setRouteTrafficResultList,

    //! bu yeni bir rota ekleyen
    addNewRoutePoint,

    //! bu süreyi backendin hesaplma yapıp yapmayacağını belirleyen şey
    setIsDurationStrict,

    //! tüm verileri sıfırlama
    clearNakliyeCalcForm

} = nakliyeHesaplamaSlice.actions
export default nakliyeHesaplamaSlice.reducer
